import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { DragDropContext } from "react-beautiful-dnd";
import { BsXLg } from "react-icons/bs";

import Dialog from "./Dialog.js";
import CollectionDroppable from "./CollectionDroppable.js";
import InvestmentDroppable from "./InvestmentDroppable.js";
import VariableDroppable from "./VariableDroppable.js";
import ImpactIcons from "./ImpactIcons.js";
import InvestmentBar from "./InvestmentBar.js";
import SolutionTitle from "./SolutionTitle.js";
import ReliabilityBadge from "./ReliabilityBadge.js";
import VariableTitle from "./VariableTitle.js";


export default function ReportModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    const [draggedDocumentId, setDraggedDocumentId] = useState(null);

    const colWidth = gData.content.params.documentWidth + 4*2 + 4*2 || "auto";
    const investmentColWidth = colWidth * 2 + 4 || "auto";
    const validation = (gData.state.vars.allowValidation === undefined || gData.state.vars.allowValidation);

    const [showValidateDialog, setShowValidateDialog] = useState(false);
    let validateDialog = (<></>);
    
    let reportPanel = (<></>);

    if (gData.state.currentSolutionId !== null)
    {
	function closeReport () { gDispatch({ type: "closeAnalysis" }); gDispatch({ type: "openReport" }); }

	const onDragStart = (result) => {
	    setDraggedDocumentId(result.draggableId);
	};
	
	const onDragEnd = (result) => {
	    setDraggedDocumentId(null);
	    
	    const { destination, source, draggableId } = result;
	    if (! destination) return;
	    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

	    const documentId = draggableId;
	    
	    const [ fromSolutionId, fromVariableId, fromValue ] = source.droppableId.split("/");
	    const from = { variableId: fromVariableId, value: fromValue, index: source.index };

	    const [ toSolutionId, toVariableId, toValue ] = destination.droppableId.split("/");
	    const to = { variableId: toVariableId, value: toValue, index: destination.index };

	    if (fromSolutionId !== toSolutionId) return;
	    // if (gData.content.params.easyInvestment && gData.content.documents[documentId].variableId !== null && toVariableId === "investment") return;
	    // if (gData.content.params.easyInvestment && gData.content.documents[documentId].variableId === null && toVariableId !== "investment" && toVariableId !== "collection") return;
	    
	    gDispatch({ type: "moveDocument", solutionId: fromSolutionId, moves: [ { documentId, from, to } ] });
	};
	
	const solutionId = gData.state.currentSolutionId;
	const result = gData.state.reports[solutionId].result;


	// HEADERS
	const collectionHeader = (
	    <div className="text-center">
		<span className="fs-5 text-secondary text-uppercase">Documents à classer</span>
	    </div>
	);

	const variableHeaders = (
	    <div className="d-flex gap-1">
		<div className="flex-shrink-0 text-center" style={{ width: colWidth }}><span className="fs-5 text-danger text-uppercase">Impacts négatifs</span></div>
		<div className="flex-shrink-0 text-center" style={{ width: colWidth }}><span className="fs-5 text-success text-uppercase">Impacts positifs</span></div>
		<div/>
	    </div>
	);


	// COLLECTION
	const collectionDroppable = (<CollectionDroppable solutionId={solutionId} draggedDocumentId={draggedDocumentId}/>);

	
	// VARIABLES
	const variableDroppables = Object.entries(gData.content.variables).map(([id, variable]) => {
	    const popover = (
		<Popover className="p-2 bg-light text-dark border-dark shadow text-center px-3" style={{ width: "240px" }}>
		    <div className="fw-medium"><VariableTitle variableId={variable.id}/></div>
		    <div>{variable.description}</div>
		</Popover>
	    );

	    return (
		<div key={variable.id} className="d-flex gap-1">
		    <div className="flex-shrink-0 d-flex justify-content-center" style={{ width: colWidth }}>
			<VariableDroppable solutionId={solutionId} variableId={variable.id} value="neg" draggedDocumentId={draggedDocumentId}/>
			{/* <VariableDroppable solutionId={solutionId} variableId={variable.id} value="neg" num="1"/> */}
		    </div>
		    <div className="flex-shrink-0 d-flex justify-content-center" style={{ width: colWidth }}>
		<VariableDroppable solutionId={solutionId} variableId={variable.id} value="pos" draggedDocumentId={draggedDocumentId}/>
		{/* <VariableDroppable solutionId={solutionId} variableId={variable.id} value="pos" num="1"/> */}
	    </div>
	    <OverlayTrigger placement="top" overlay={popover}>
		{({ ref, ...triggerHandler }) => (
			<div className="flex-shrink-1 d-flex flex-column justify-content-center ms-1" {...triggerHandler}>
			    {/* <span>sur</span> */}
			    <div className="d-flex align-items-end gap-2">
				<span className="fs-3" ref={ref}><VariableTitle variableId={variable.id} icon={"only"}/></span>
				<span className="fs-5 text-uppercase">{gData.content.variables[variable.id].title}</span>
			    </div>
			    <ImpactIcons solutionId={solutionId} variableId={variable.id} type={"analysis"}/>
			</div>
		)}
	    </OverlayTrigger>
	    </div>
	    );
	});

	
	// INVESTMENT
	const popover = (
	    <Popover className="p-2 bg-light text-dark border-dark shadow text-center px-3" style={{ width: "240px" }}>
		<div className="fw-medium"><VariableTitle variableId={"investment"}/></div>
		<div>Budget disponible pour des achats de long terme</div>
	    </Popover>
	);

	const investmentDroppable = (
	    <div className="d-flex gap-1">
		{/* <div className="flex-shrink-0 d-flex justify-content-center" style={{ width: colWidth }}></div> */}
		<div className="flex-shrink-0 d-flex justify-content-center" style={{ width: investmentColWidth }}>
		    <InvestmentDroppable solutionId={solutionId} draggedDocumentId={draggedDocumentId}/>
		</div>
		<OverlayTrigger placement="top" overlay={popover}>
		    {({ ref, ...triggerHandler }) => (
			<div className="flex-shrink-1 d-flex flex-column justify-content-center ms-1" {...triggerHandler}>
			    <div className="d-flex align-items-end gap-2">
				<span className="fs-3" ref={ref}><VariableTitle variableId={"investment"} icon={"only"}/></span>
				<span className="fs-5 text-uppercase">Investissements</span>
			    </div>
			    <InvestmentBar solutionId={solutionId} type={"analysis"}/>
			    {/* <ImpactIcons solutionId={solutionId} variableId={variable.id}/> */}
			</div>
		    )}
		</OverlayTrigger>
	    </div>
	);

	validateDialog = (
	    <Dialog show={showValidateDialog} hide={() => setShowValidateDialog(false)} confirm={validateReport} title="Valider l'analyse ?">
		<p>Attention : il ne sera plus possible de modifier votre analyse après validation, même si vous obtenez par la suite de nouveaux documents ou avis concernant cette solution.</p>
	    </Dialog>
	);


	function validateReport ()
	{
	    // INIT RESULT STRUCTURE
	    const result = {
		reliability: 0,
		maxReliability: 0,
		investment: { id: "investment", realCost: 0, estCost: 0, reliability: 0, maxReliability: 0 },
		variables: Object.fromEntries(
		    Object.entries(gData.content.variables).map(([id, variable]) => [id, { id, realImpact: 0, estPosImpact: 0, estNegImpact: 0, reliability: 0, maxReliability: 0 }])
		),
	    };

	    // FILL RESULT STRUCTURE
	    const solutionContent = gData.content.solutions[solutionId];
	    result.investment.realCost = solutionContent.cost;

	    Object.entries(gData.content.variables).forEach(([id, variable]) => { result.variables[variable.id].realImpact = solutionContent.variables[variable.id].impact; });
	    //Object.entries(solutionContent.variables).forEach(([id, variable]) => { result.variables[variable.id].realImpact = variable.impact; });
	    Object.entries(gData.content.documents).filter(([id, document]) => document.solutionId === solutionId).forEach(([id, document]) => {
		result.maxReliability++;
		if (document.variableId === null) { result.investment.maxReliability++; }
		else {
		    result.variables[document.variableId].maxReliability++;
		    /* if (document.value === "pos") result.variables[document.variableId].posNb++; else if (document.value === "neg") result.variables[document.variableId].negNb++; */
		}
	    });

	    /* Object.entries(result.variables).forEach(([id, variable]) => {
	       variable.posImpact = 0;
	       variable.negImpact = 0;
	       
	       if (variable.realImpact > 0)
	       {
	       if (variable.posNb === 0) console.log("REPORT WARNING:\n - solution \"" + solutionId + "\"\n - variable \"" + variable.id + "\"\n - positive impact with no positive documents");
	       if (variable.negNb === 0) variable.posImpact = variable.realImpact / variable.posNb;
	       else {
	       variable.negImpact = -impactRef;
	       variable.posImpact = (variable.realImpact - variable.negNb * variable.negImpact) / variable.posNb;
	       }
	       }

	       else if (variable.realImpact < 0)
	       {
	       if (variable.negNb === 0) console.log("REPORT WARNING:\n - solution \"" + solutionId + "\"\n - variable \"" + variable.id + "\"\n - negative impact with no negative documents");
	       if (variable.posNb === 0) variable.negImpact = variable.realImpact / variable.negNb;
	       else {
	       variable.posImpact = impactRef;
	       variable.negImpact = (variable.realImpact - variable.posNb * variable.posImpact) / variable.negNb;
	       }
	       }

	       else if (variable.realImpact === 0)
	       {
	       if (variable.posNb > 0 || variable.negNb > 0)
	       {
	       if (variable.posNb === 0) console.log("REPORT WARNING:\n - solution \"" + solutionId + "\"\n - variable \"" + variable.id + "\"\n - neutral impact and negative documents with no positive document");
	       else if (variable.negNb === 0) console.log("REPORT WARNING:\n - solution \"" + solutionId + "\"\n - variable \"" + variable.id + "\"\n - neutral impact and positive documents with no negative document");
	       else {
	       variable.posImpact = impactRef / variable.posNb;
	       variable.negImpact = -impactRef / variable.negNb;
	       }
	       }
	       }
	       }); */
	    

	    // COMPUTE RESULT STRUCTURE
	    const report = gData.state.reports[solutionId];
	    
	    Object.entries(report.variables).forEach(([id, variable]) => {
		["pos", "neg"].forEach((value) => {
		    variable[value].documentIds.forEach((documentId) => {
			const documentContent = gData.content.documents[documentId];
			const check = documentContent.variableId === variable.id && documentContent.value === value;
			if (check) {
			    result.reliability++;

			    const variable = result.variables[documentContent.variableId];
			    variable.reliability++;

			    if (documentContent.value === "pos") variable.estPosImpact += documentContent.impact;
			    else if (documentContent.value === "neg") variable.estNegImpact -= documentContent.impact;
			}
		    });
		});
	    });

	    report.investment.documentIds.forEach((documentId) => {
		const documentContent = gData.content.documents[documentId];
		const check = documentContent.variableId === null;
		if (check) {
		    result.reliability++;
		    result.investment.reliability++;
		    result.investment.estCost += documentContent.cost;
		}
	    });

	    //console.log(result);
	    gDispatch({ type: "addReportResult", solutionId, result });
	    //gDispatch({ type: "closeAnalysis" });
	    //gDispatch({ type: "openResult", solutionId });
	}

	reportPanel = (
	    <>
		<Modal
		    dialogClassName="modal-xxl"
		    contentClassName="modal-content-xxl"
		    backdropClassName="opacity-0"
		    show={gData.state.showModals.analysis}
		    onHide={closeReport}
		    centered
		>
		    <Modal.Header className="d-flex align-items-center justify-content-between bg-light">
			<div className="d-flex gap-2 align-items-center">
			    <span className="fs-4 fw-medium text-uppercase">Analyse de</span>
			    <SolutionTitle solutionId={solutionId} size="md"/>
			</div>
			<div className="d-flex gap-2">
			    {(result === null && validation) && (<Button onClick={() => setShowValidateDialog(true)}>Valider l'analyse</Button>)}
			    {(result !== null && false) && (<ReliabilityBadge solutionId={solutionId} big={true}/>)}
			    <Button variant="secondary" onClick={closeReport}><BsXLg/></Button>
			</div>
		    </Modal.Header>
		    <Modal.Body>
			<DragDropContext
			    onDragStart={onDragStart}
			    onDragEnd={onDragEnd}
			>
			    <div className="d-flex gap-3 justify-content-evenly align-items-center h-100">
				<div className="d-flex flex-column gap-3">
				    <div className="d-flex flex-column gap-1">
					{collectionHeader}
					{collectionDroppable}
					<div className="opacity-0">{collectionHeader}</div>
				    </div>
				</div>
				<div className="d-flex flex-column gap-1">
				    {variableHeaders}
				    <div className="d-flex flex-column gap-3">
					{variableDroppables}
					{investmentDroppable}
				    </div>
				    <div className="opacity-0">{variableHeaders}</div>
				</div>
			    </div>
			</DragDropContext>
		    </Modal.Body>
		</Modal>
		{validateDialog}
	    </>
	);
    }
    
    return reportPanel;
}
